import { authFetch } from "./authFetch";

export const smsReceiverApi = {
    getList: () => authFetch("/api/sms-receivers").then(r => r.json()),
    create: (data) => authFetch("/api/sms-receivers", {
        method: "POST",
        body: JSON.stringify(data)
    }).then(r => r.json()),
    update: (id, data) => authFetch(`/api/sms-receivers/${id}`, {
        method: "PUT",
        body: JSON.stringify(data)
    }).then(r => r.json()),
    delete: (id) => authFetch(`/api/sms-receivers/${id}`, {
        method: "DELETE"
    }).then(r => r.json())
};
// ============================================================
// [SMS_GROUP_V1] 수신처 "그룹" 전용 API
//
// 왜 따로 있나
//   그룹은 원래 sms_receivers.group_name 이라는 글자일 뿐이라
//   사람이 0명인 그룹은 존재할 수 없었다(= 그룹 추가 불가).
//   백엔드에 sms_groups 테이블을 두어 빈 그룹도 남게 했고, 그 창구가 이것이다.
//
// 주소는 /api/sms-receivers/groups — 기존 수신처 라우터 안에 있어
// 인증(premium·admin)이 그대로 적용된다.
//
// 연관 파일
//   backend/routes/smsReceivers.js               서버 쪽 구현
//   components/GroupManageModal.jsx              그룹 추가·이름변경·삭제 화면
//   pages/ReceiverManagePage.jsx                 그룹 골라 보기
// ============================================================
export const smsGroupApi = {
    list:   ()         => authFetch("/api/sms-receivers/groups").then(r => r.json()),
    create: (data)     => authFetch("/api/sms-receivers/groups", {
        method: "POST",
        body: JSON.stringify(data)
    }).then(r => r.json()),
    update: (id, data) => authFetch(`/api/sms-receivers/groups/${id}`, {
        method: "PUT",
        body: JSON.stringify(data)
    }).then(r => r.json()),
    remove: (id)       => authFetch(`/api/sms-receivers/groups/${id}`, {
        method: "DELETE"
    }).then(r => r.json()),
};
